var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "netherlands",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 15,
    cy: 14.777,
    rx: 15,
    ry: 14.777,
    transform: "translate(-0.001 0.253)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M29.952,0A14.967,14.967,0,0,0,15.923,9.783H43.981A14.967,14.967,0,0,0,29.952,0Z",
    transform: "translate(-15.134 0.001)",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M29.952,354.826a14.967,14.967,0,0,0,14.029-9.783H15.923A14.967,14.967,0,0,0,29.952,354.826Z",
    transform: "translate(-15.134 -324.825)",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNl);
export default __webpack_public_path__ + "static/media/NL.f89b8d9360a5cbca4240e439f4748886.svg";
export { ForwardRef as ReactComponent };